/*
 * システム設定
 */
const route = {
    name: "SystemSetting",
    path: "/systemsetting",
    view: "SystemSetting",
    component: () =>
        import ("../SystemSetting.vue"),
    meta: {
        title: "システム設定"
    }
}

export default route
